import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { InterestAcrualType } from '../../../../../../../../../../common/constants/InterestAcrualType';
import { InterestAcrualTypeOptions } from '../../../../../../../../../../common/constants/InterestAcrualTypeOptions';

/** Defaults by Loan Type when the Loan Type is chosen (see getDefaultInterestAccrualType). */
export const InterestAccrualField = () => {
    const value = useStandardLoanStore((state) => state.loan.interestAcrualTypeId);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <DropDownBox
            id='loanInterestAcrualTypeId'
            value={value ?? null}
            onChange={(interestAcrualTypeId: InterestAcrualType | null) =>
                updateLoan({ interestAcrualTypeId: interestAcrualTypeId ?? undefined })
            }
            label='Interest Accrual'
            dataSource={InterestAcrualTypeOptions}
            displayExpr='name'
            valueExpr='id'
            placeholder='Select'
            searchEnabled={false}
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
